export default __webpack_public_path__ + "static/media/gift_finder.5d204e0d.png";